/* Sample Kit PDP — buy box behaviour.
   Gallery carousel, free-scrolling video rail, accordions and AJAX add-to-cart.
   Everything is scoped to one section root so the theme editor can re-init a
   single section without touching the rest of the page. */
(function () {
  'use strict';

  // This file is emitted by every instance of its section, so it can be
  // executed several times on one page. Bind once; later copies bail out.
  if (window.__skpBuyBoxInit) return;
  window.__skpBuyBoxInit = true;

  var instances = new WeakMap();

  function waitForSwiper(cb) {
    if (window.Swiper) return cb();
    var tries = 0;
    var timer = setInterval(function () {
      if (window.Swiper || ++tries > 100) {
        clearInterval(timer);
        if (window.Swiper) cb();
      }
    }, 50);
  }

  /* ---------------------------------------------------------------- */
  /* Gallery                                                           */
  /* ---------------------------------------------------------------- */

  function initGallery(root, state) {
    var el = root.querySelector('[data-skp-gallery]');
    if (!el) return;

    // Stop the browser's native image drag from hijacking a swipe.
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-skp-thumb]'));
    var slideCount = el.querySelectorAll('.swiper-slide').length;

    var swiper = new Swiper(el, {
      // Swiper needs at least two slides to build a usable loop; with one
      // image looping would clone nothing and jump.
      loop: slideCount > 1,
      speed: 400,
      spaceBetween: 0,
      slidesPerView: 1,
      grabCursor: true,
      watchOverflow: true,
      on: {
        slideChange: function () {
          var real = typeof this.realIndex === 'number' ? this.realIndex : this.activeIndex;
          thumbs.forEach(function (t, i) {
            t.classList.toggle('is-active', i === real);
            t.setAttribute('aria-current', i === real ? 'true' : 'false');
          });
        }
      }
    });

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        if (swiper.params.loop) swiper.slideToLoop(i);
        else swiper.slideTo(i);
      });
    });

    state.gallery = swiper;
  }

  /* ---------------------------------------------------------------- */
  /* Video rail — free scroll, one video playing at a time             */
  /* ---------------------------------------------------------------- */

  function initVideos(root, state) {
    var el = root.querySelector('[data-skp-videos]');
    if (!el) return;

    el.addEventListener('dragstart', function (e) { e.preventDefault(); });

    state.videos = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: parseInt(el.getAttribute('data-gap'), 10) || 12,
      // Free, momentum-based dragging rather than snapping slide by slide.
      freeMode: {
        enabled: true,
        momentum: true,
        momentumRatio: 0.8,
        momentumBounce: false
      },
      grabCursor: true,
      watchOverflow: true,
      resistanceRatio: 0.4
    });

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-skp-video]'));
    var unmuteOnPlay = el.getAttribute('data-unmute') !== 'false';

    // Keep the element, the button class and the ARIA state in one place so
    // they can never disagree about whether sound is on.
    function setMuted(video, sound, muted) {
      video.muted = muted;
      if (!sound) return;
      sound.classList.toggle('is-muted', muted);
      sound.setAttribute('aria-pressed', muted ? 'false' : 'true');
    }

    function stopAll(except) {
      cards.forEach(function (card) {
        if (card === except) return;
        var v = card.querySelector('video');
        if (v) {
          v.pause();
          v.currentTime = 0;
          // Reset to silent so the next video starts from a known state.
          setMuted(v, card.querySelector('[data-skp-video-sound]'), true);
        }
        card.classList.remove('is-playing');
      });
    }

    cards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;

      var sound = card.querySelector('[data-skp-video-sound]');

      // Distinguish a tap from the end of a drag by how far the pointer
      // actually travelled during THIS interaction.
      var downX = null, downY = null;
      card.addEventListener('pointerdown', function (e) {
        downX = e.clientX;
        downY = e.clientY;
      });
      function dragged(e) {
        if (downX === null) return false;
        var dx = e.clientX - downX, dy = e.clientY - downY;
        return Math.sqrt(dx * dx + dy * dy) > 8;
      }

      card.addEventListener('click', function (e) {
        // The sound button has its own handler.
        if (e.target.closest('[data-skp-video-sound]')) return;
        if (dragged(e)) return;

        if (video.paused) {
          stopAll(card);
          card.classList.add('is-playing');
          // A click is a user gesture, so playing with sound is permitted.
          if (unmuteOnPlay) setMuted(video, sound, false);
          var p = video.play();
          if (p && p.catch) {
            p.catch(function () {
              // Sound refused by the browser: fall back to muted playback
              // rather than leaving the reader with a dead play button.
              setMuted(video, sound, true);
              var retry = video.play();
              if (retry && retry.catch) {
                retry.catch(function () { card.classList.remove('is-playing'); });
              }
            });
          }
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      });

      video.addEventListener('ended', function () {
        card.classList.remove('is-playing');
        video.currentTime = 0;
      });

      if (sound) {
        sound.addEventListener('click', function (e) {
          e.stopPropagation();
          setMuted(video, sound, !video.muted);
        });
      }
    });

    state.stopAllVideos = stopAll;
  }

  /* ---------------------------------------------------------------- */
  /* Accordion — one open at a time, height animated for smoothness    */
  /* ---------------------------------------------------------------- */

  function initAccordions(root) {
    var toggles = Array.prototype.slice.call(root.querySelectorAll('[data-skp-acc-toggle]'));

    // Resolve the panel by id, falling back to the element right after the
    // toggle. Ids are generated from section.id, and an unexpected or
    // duplicated one would silently break every accordion on the page.
    function panelFor(toggle) {
      var id = toggle.getAttribute('aria-controls');
      var byId = id ? document.getElementById(id) : null;
      return byId || toggle.nextElementSibling;
    }

    function close(toggle) {
      var panel = panelFor(toggle);
      if (!panel) return;
      // Pin the current height before collapsing so the transition has a start
      // value to animate from.
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () {
        panel.style.height = '0px';
      });
      toggle.setAttribute('aria-expanded', 'false');
    }

    function open(toggle) {
      var panel = panelFor(toggle);
      if (!panel) return;
      panel.style.height = panel.scrollHeight + 'px';
      toggle.setAttribute('aria-expanded', 'true');
      // Once expanded, release to auto so the panel reflows if its content or
      // the viewport width changes.
      panel.addEventListener('transitionend', function handler(e) {
        if (e.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', handler);
        if (toggle.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
      });
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggles.forEach(function (other) {
          if (other !== toggle && other.getAttribute('aria-expanded') === 'true') close(other);
        });
        if (isOpen) close(toggle);
        else open(toggle);
      });
    });
  }

  /* ---------------------------------------------------------------- */
  /* Rating — scroll to the reviews section                            */
  /* ---------------------------------------------------------------- */

  function initRating(root) {
    var trigger = root.querySelector('[data-skp-rating]');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var targetSel = trigger.getAttribute('data-target');
      var target = null;
      if (targetSel) {
        try { target = document.querySelector(targetSel); } catch (e) { target = null; }
      }
      // No silent fallback: an unmatched selector used to send the reader to
      // whatever the old Okendo guess happened to find.
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------------------------------------------------------------- */
  /* AJAX add to cart                                                  */
  /* ---------------------------------------------------------------- */

  function openCartDrawer() {
    if (typeof window.openSidecart === 'function') {
      window.openSidecart();
      return true;
    }
    // Fall back to the theme's cart icon if the global isn't ready yet.
    var icon = document.querySelector('[data-sidecart-open]');
    if (icon) {
      icon.click();
      return true;
    }
    return false;
  }

  function initForm(root) {
    var form = root.querySelector('[data-skp-form]');
    if (!form) return;

    var button = form.querySelector('[data-skp-atc]');
    var label = button ? button.querySelector('[data-skp-atc-label]') : null;
    var errorEl = root.querySelector('[data-skp-atc-error]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!button || button.hasAttribute('disabled')) return;

      var original = label ? label.textContent : '';
      button.setAttribute('disabled', 'disabled');
      if (label) label.textContent = button.getAttribute('data-adding-text') || 'Adding…';
      if (errorEl) errorEl.textContent = '';

      fetch(window.Shopify && window.routes ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(form.querySelector('[name="id"]').value, 10),
            quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10)
          }]
        })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error(body.description || body.message || 'Add to cart failed');
            return body;
          });
        })
        .then(function () {
          if (!openCartDrawer()) window.location.href = '/cart';
          document.dispatchEvent(new CustomEvent('skp:cart:added'));
        })
        .catch(function (err) {
          if (errorEl) errorEl.textContent = err.message;
        })
        .finally(function () {
          button.removeAttribute('disabled');
          if (label) label.textContent = original;
        });
    });
  }

  /* ---------------------------------------------------------------- */

  function destroy(root) {
    var state = instances.get(root);
    if (!state) return;
    if (state.gallery && state.gallery.destroy) state.gallery.destroy(true, true);
    if (state.videos && state.videos.destroy) state.videos.destroy(true, true);
    instances.delete(root);
  }

  function init(root) {
    if (!root || instances.has(root)) return;
    // Survives across separate executions of this file, unlike the WeakMap.
    if (root.hasAttribute('data-skp-bound')) return;
    root.setAttribute('data-skp-bound', '');
    var state = {};
    instances.set(root, state);

    initAccordions(root);
    initRating(root);
    initForm(root);
    waitForSwiper(function () {
      initGallery(root, state);
      initVideos(root, state);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-skp-buy-box]').forEach(function (root) {
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: rebuild only the section that changed.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-skp-buy-box]').forEach(destroy);
  });
})();
